const PromotionViewsSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" fill="none">
            <ellipse cx="8.177" cy="8" fill="#546EDB" rx="8.129" ry="8"/><path fill="#fff" d="M8.177 4C5.46 4 2.995 5.463 1.176 7.84a.547.547 0 0 0 0 .662c1.819 2.38 4.283 3.843 7.001 3.843s5.183-1.463 7.002-3.84a.547.547 0 0 0 0-.662C13.36 5.463 10.895 4 8.177 4Zm.195 7.111c-1.804.112-3.294-1.352-3.18-3.13.093-1.467 1.3-2.655 2.79-2.747 1.805-.111 3.295 1.352 3.181 3.13-.096 1.464-1.304 2.652-2.79 2.747Zm-.09-1.357c-.972.06-1.775-.728-1.711-1.684.05-.79.701-1.43 1.505-1.481.971-.06 1.775.727 1.71 1.684a1.605 1.605 0 0 1-1.504 1.48Z"/>
        </svg>
    )
}

export default PromotionViewsSvg;